export default function ReloadPageLink({ href: _href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href="#"
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()

        window.location.reload()
      }}
    >
      {children}
    </a>
  )
}
